import { render, staticRenderFns } from "./region-str-history.vue?vue&type=template&id=1dc63136&scoped=true"
import script from "./region-str-history.vue?vue&type=script&lang=js"
export * from "./region-str-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7sjryms56nihpddmmbru7sns3m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc63136",
  null
  
)

export default component.exports